import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSettings } from '../contexts/SettingsContext';

interface AiChatRouteProps {
  children: React.ReactNode;
}

const AiChatRoute: React.FC<AiChatRouteProps> = ({ children }) => {
  const { isAiChatEnabled, isLoading } = useSettings();

  if (isLoading) return null;
  if (!isAiChatEnabled) return <Navigate to="/dashboard/apt" replace />;

  return <>{children}</>;
};

export default AiChatRoute;
